export default {
	install(Vue) {
		Vue.prototype.$openDripForm = function() {
			// console.log("Open drip form!!!");
			window._dcq.push(["showForm", { id: "938849579" }]);
		};
	}
};
